import ImagesPallet from "../../../../../utils/ImagesPallet";

const productListData = [
  // {
  //   name: "Loreal Series Expert Vitamino Conditioner Rinse 750ml",
  //   price: "IDR 480K",
  //   category: "conditioner",
  //   description: "Conditioner untuk rambut berwarna, melindungi warna & memberikan kilau",
  //   rating: 4.8,
  //   stock: 15,
  //   image: ImagesPallet.Product11,
  // },
  // {
  //   name: "Loreal Series Expert Absolut Repair Gold Conditioner 750ml",
  //   price: "IDR 480K",
  //   category: "conditioner",
  //   description: "Conditioner untuk rambut rusak, memperbaiki & memberikan nutrisi mendalam",
  //   rating: 4.7,
  //   stock: 20,
  //   image: ImagesPallet.Product7,
  // },
  {
    name: "Loreal Series Expert Vitamino Shampoo 300ml",
    price: "IDR 275K",
    category: "shampoo",
    description: "Shampoo khusus rambut berwarna, menjaga warna tetap cerah & tahan lama",
    rating: 4.6,
    stock: 12,
    image: ImagesPallet.Product4,
  },
  {
    name: "Loreal Series Expert Silver Shampoo 300ml",
    price: "IDR 275K",
    category: "shampoo",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.7,
    stock: 18,
    image: ImagesPallet.Product5,
  },
  {
    name: "Loreal Series Expert Molecular Rinse-off serum 250ml",
    price: "IDR 545K",
    category: "serum",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.7,
    stock: 18,
    image: ImagesPallet.Product3,
  },
  {
    name: "Loreal Series Expert Silver Conditioner Rinse 200ml",
    price: "IDR 325K",
    category: "conditioner",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.7,
    stock: 18,
    image: ImagesPallet.Product6,
  },
  {
    name: "Loreal Series Expert Absolut Repair Gold Conditioner 200ml",
    price: "IDR 325K",
    category: "conditioner",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.5,
    stock: 18,
    image: ImagesPallet.Product8,
  },
  {
    name: "Loreal Series Expert Vitamino Conditioner Rinse 200ml",
    price: "IDR 222K",
    category: "conditioner",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product9,
  },
  {
    name: "Loreal Series Expert Vitamino Hair Mask 500ml",
    price: "IDR 780K",
    category: "hair mask",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product12,
  },
  {
    name: "Loreal Series Expert Hair Spa Cream Deep Nourishing 500ml",
    price: "IDR 260K",
    category: "hair spa",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product13,
  },
  {
    name: "Loreal Series Expert Absolut Repair Leave-in Mask 100ml",
    price: "IDR 500K",
    category: "hair mask",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product16,
  },
  {
    name: "Loreal Series Expert Scalp Advance 5-in-1 Serum 90ml",
    price: "IDR 645K",
    category: "serum",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product17,
  },
  {
    name: "Loreal Series Expert Hair Spa Ice Scrub 150ml",
    price: "IDR 225K",
    category: "hair spa",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product18,
  },
  {
    name: "Loreal Series Expert Hair Spa Purifying Concentrate 8ml",
    price: "IDR 60K",
    category: "hair spa",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product19,
  },
  {
    name: "Loreal Series Expert Hair Spa Purifying Concentrate 6 x 8ml",
    price: "IDR 260K",
    category: "hair spa",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product20,
  },
  {
    name: "Loreal Series Expert Hair Spa Purifying Concentrate 6 x 8ml",
    price: "IDR 260K",
    category: "Hair Spa",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product21,
  },
  {
    name: "Loreal Series Expert Hair Spa Cream Smooth 500ml",
    price: "IDR 260K",
    category: "hair spa",
    description: "Shampoo untuk rambut silver/platinum, menetralkan warna kuning & mencerahkan",
    rating: 4.2,
    stock: 18,
    image: ImagesPallet.Product22,
  },
];  

export default productListData;